import React, { Component } from "react";
import "./UnverifiedAccountPage.scss";
import ReactGA from "react-ga";

import { ReactComponent as Image } from "./desktop-image.svg";
import CompanyLogo from "../../assets/radarr-logo.png";
import { Link } from "react-router-dom";

class UnverifiedAccountPage extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        document.title = "Radarr";
    }

    render() {
        return (
            <div className="unverified-user">
                <div className="nav-bar">
                    <img className="companyLogo" src={CompanyLogo} />
                    <Link to="/signout" className="account">
                        <div className="sign-out">Sign Out</div>
                    </Link>
                </div>
                <div className="content">
                    <div className="info">
                        <h2>Congratulations!</h2>
                        <p>You account has been created.</p>
                        <p>This application has been optimized to run in a desktop environment.</p>
                        <p className="message">Please login using a desktop to experience the power of Radarr.</p>
                    </div>
                    <div className="image">
                        <Image />
                    </div>
                </div>
            </div>
        );
    }
}

export default UnverifiedAccountPage;
